import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { DatatableApi, Datatable, DatatableOptions } from '../../Widgets/Datatable'
import { MultiSelectApi } from '../../Widgets/MultiSelect'
import { Utils } from '../../Utils/Utils';
import { DateUtils } from '../../Utils/DateUtils';
import { StringUtils } from '../../Utils/StringUtils';
import { ArrayUtils } from '../../Utils/ArrayUtils';

var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'f><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";

export interface IndexPageOptions extends PageOptionsBase {
    urlList: string;
    urlDetail: string;
    localizer: {
        StatusEnabled: string;
        StatusDisabled: string;
    }
}

export class BuildDetailPage extends PageBase<IndexPageOptions> {
    protected  _tableOptions: DatatableOptions;
    protected  _table: Datatable;
    protected  _tableId: string;

    constructor(options: IndexPageOptions) {
        super(options);

        var getDetailUrl = (rowData: any): string => (`${options.urlDetail}/${rowData.Id}`);

        this._tableId = "tableCustomerOperations";
        // === prepare table options
        this._tableOptions = {
            url: this._options.urlList,
            dom: tableDom,
            rowId: 'Id',
            autoWidth: true,
            autoFocusSearch: false,
            columns: [
                {
                    data: "CustomerName",
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnCustomerName${rowData.Id}'>${data}</span>`)
                },
                {
                    data: 'CustomerOperationName',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnName${rowData.Id}'>${data}</span>`)
                },
                {
                    data: 'Currencies',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnCurrencies${rowData.Id}'>${data}</span>`)
                },
                {
                    data: "GameStatus",
                    render: (data: any, type: any, rowData: any) => {
                        var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
                        var css = data === true ? 'status-enabled' : 'status-disabled';
                        return `<span id='spnState${rowData.Id}' class='${css}'>${text}</span>`;
                    }
                }
            ]
        };

        
    }

    init(): void {
        // == create 'new Datatable' instance
        this._table = new Datatable(this._tableId, this._tableOptions);
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/Games/BuildDetailpage.ts
 **/